/**
 * Authentication API calls
 */

import { apiClient, setTokens, clearTokens } from './client';
import type {
  LoginRequest,
  LoginResponse,
  TokenRefreshResponse,
  User,
} from '@/types/auth';

export const authApi = {
  /**
   * Login user
   */
  login: async (credentials: LoginRequest): Promise<LoginResponse> => {
    const response = await apiClient.post<LoginResponse>('/token/', credentials);
    const { access, refresh, user } = response.data;
    
    // Store tokens
    setTokens(access, refresh);
    
    return { access, refresh, user };
  },

  /**
   * Logout user
   */
  logout: async (): Promise<void> => {
    clearTokens();
  },

  /**
   * Refresh access token
   */
  refreshToken: async (): Promise<string> => {
    const response = await apiClient.post<TokenRefreshResponse>('/token/refresh/');
    return response.data.access;
  },

  /**
   * Get current user profile
   */
  getCurrentUser: async (): Promise<User> => {
    const response = await apiClient.get<{ output: User }>('/user/profile/');
    return response.data.output;
  },
};
